import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router'
import clsx from 'clsx'
import { AsideMenuMain } from './AsideMenuMain'
import { DrawerComponent, ScrollTopComponent, ToggleComponent } from '../../assets/components'

type Props = {
  asideMenuCSSClasses: string[]
}

/**
 * Contenedor del menu del sidebar con scroll.
 * Re-inicializa componentes KTMetric al cambiar de ruta y resetea scroll a tope.
 */
const AsideMenu: React.FC<Props> = ({ asideMenuCSSClasses }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollTopComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div id='kt_aside_menu_wrapper' ref={scrollRef} className='hover-scroll-overlay-y my-5 my-lg-5'>
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className={clsx(
          'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
          asideMenuCSSClasses.join(' ')
        )}>
        <AsideMenuMain />
      </div>
    </div>
  )
}

export { AsideMenu }
